import { render, staticRenderFns } from "./SMSMetrics.vue?vue&type=template&id=095f343a"
import script from "./SMSMetrics.vue?vue&type=script&lang=js"
export * from "./SMSMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports